import contentProductDetails from "./contentProductDetails"
export default contentProductDetails;
